export const UPDATE_STEPS = 'UPDATE_STEPS'
export const INIT_FORM_DATA = 'INIT_FORM_DATA'
export const UPDATE_FORM_DATA = 'UPDATE_FORM_DATA'
export const UPDATE_INFO = 'UPDATE_INFO'
export const CLEAR_TEST = 'CLEAR_TEST'
